
// READ⬆
export function ReadAuthUp(auth) {
    if (
        auth != "ALL" &&
        auth != "WRITE" &&
        auth != "READ_DOWNLOAD" &&
        auth != "READ"
    ) {
        return false;
    }
    return true;
}

// READ_DOWNLOAD⬆
export function ReadDownloadAuthUp(auth) {
    if (
        auth != "ALL" &&
        auth != "WRITE" &&
        auth != "READ_DOWNLOAD"
    ) {
        return false;
    }
    return true;
}

// WRITE⬆
export function WriteAuthUp(auth) {
    if (
        auth != "ALL" &&
        auth != "WRITE"
    ) {
        return false;
    }
    return true;
}

// ALL⬆
export function AllAuthUp(auth) {
    if (auth != "ALL") {
        return false;
    }
    return true;
}